/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-04-20 14:03:38
 * @modify date 2020-04-20 14:03:38
 * @desc [description]
 */
import axios from 'axios';

/**
 * getUserRegistrationCount get api
 * to get the total registration counts */
export async function getUserRegistrationCount() {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/user_registrations_count`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get user_registrations_count python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getCountryCertificateAuth get api
 * to the certificates list */
export async function getCountryCertificateAuth() {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/country_certificate_auth`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('country_certificate_auth python api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getArchivingReasons get api
 * to get the exisiting reasons */
export async function getArchivingReasons() {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/archiving_reasons`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get archiving_reasons python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationDetails get api
 * to get Registration Details */
export async function getRegistrationDetails(finalRecords) {
  let result = [];
  await axios
    .post(`${process.env.VUE_APP_PYTHON_API_URL}/registrations`, finalRecords)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('getRegistrationDetails python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * get_account_records_details get api
 * to get the account records upload details */
export async function getRecordUploadDetails() {
  let result = {};
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/account_record_details`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get account_records_details python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationTypeList get api
 * to get registration type list */
export async function getRegistrationTypeList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/registration_type`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get registration_type python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getCertificateList get api
 * to get the certificate List */
export async function getCertificateList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/certificate`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get certificate python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getCompanyList get api
 * to get the companies list */
export async function getCompanyList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/company`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get company python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getMedCompContacts get api
 * to get Med Comp Contacts */
export async function getMedCompContacts() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/med_comp_contacts`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get med_comp_contacts python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductList get api
 * to get the prodcuts list */
export async function getProductList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/product_list`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get product_list python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationStatus get api
 * to get the registration status */
export async function getRegistrationStatus() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/registration_status`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get registration_status python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getLocalDistributor get api
 * to get Local Distributor list */
export async function getLocalDistributor() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/local_distributor`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get local_distributor java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getLocalRepresentative get api
 * to get the local Representation */
export async function getLocalRepresentative() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/local_representative`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get local_representative python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductPartNumber get api
 * to get the product part numbers */
export async function getProductPartNumber() {
  let result = {};
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/part_number`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get part_number python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductType get api
 * to get all the product types */
export async function getProductType() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/product_type`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get product_type python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductFamily get api
 * to get the Product Family */
export async function getProductFamily() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/product_family`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get product_family python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getCertificateIssuerList get api
 * to get Certificate Issuer List */
export async function getCertificateIssuerList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/certificate_issuer`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get certificate_issuer python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductClass get api
 * to get the ProductClass based on countryid */
export async function getProductClass(countryId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/product_class/${countryId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get product_class python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getCertificateCountryAlert get api
 * to get CertificateCountryAlert based on country and recordname */
export async function getCertificateCountryAlert(countryId, recordName) {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/certificate_country_alert/${countryId}/${recordName}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get certificate_country_alert python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRelatedCertificates get api
 * to get the realted certificates based on registration id */
export async function getRelatedCertificates(regId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/registration_related_certificates/${regId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get registration_related_certificates python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationHistory get api
 * to get the registration history */
export async function getRegistrationHistory(regId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/registration_history/${regId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get registration_history python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * saveMultiRegistrationDetails post api
 * to save bulk upload of registration */
export async function saveMultiRegistrationDetails(data) {
  let result = {};
  await axios
    .post(`${process.env.VUE_APP_PYTHON_API_URL}/multi_registration`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('save multi_registration python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * saveRegistrationDetails post api
 * to save single Registration Details */
export async function saveRegistrationDetails(data) {
  let result = {};
  await axios
    .post(`${process.env.VUE_APP_PYTHON_API_URL}/registration`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('save Registration python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * editRegistration post api
 * to update the registration */
export async function editRegistration(data) {
  let result = {};
  await axios
    .put(`${process.env.VUE_APP_PYTHON_API_URL}/registration`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('put call /registration python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * checkDuplicateRegistration post api
 * to check Duplicate Registration */
export async function checkDuplicateRegistration(data) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_PYTHON_API_URL}/check_duplicate_registrations`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('check_duplicate_registrations python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * deleteMultiRegistrationDetails delete api
 * to delete Multiple RegistrationDetails */
export async function deleteMultiRegistrationDetails(data) {
  let result = '';
  await axios
    .delete(`${process.env.VUE_APP_PYTHON_API_URL}/multi_registration`, { data })
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('delete multi_registration python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * archiveMultiRegistrationDetails post api
 * to archive Multiple RegistrationDetails */
export async function archiveMultiRegistrationDetails(option, data) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_PYTHON_API_URL}/archive_multi_registration/${option}`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('archive_multi_registration python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationDetail get api
 * to get the registration details by passing id */
export async function getRegistrationDetailsById(id) {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/registration_detail/${id}`)
    .then((response) => {
      if (response.status === 200 && response.data.status === 'invalid') {
        result = { error: true };
      } else if (response.status === 200 && response.data[0]) {
        [result] = response.data;
      }
    })
    .catch((err) => {
      console.log('get registration_detail python api error', err); // eslint-disable-line no-console
    });
  return result;
}
